import React, { useEffect, useState } from "react";

import commonFunction from "../../../../lib/utils/common";
// import styles from "./index.module.css";

export default function HotelAdvSearch(props) {
  console.log("propsprops",props)
  const getRatingLabel = (props) => {
  const selectedStars = [];

  if (props.isFiveStar) selectedStars.push("5");
  if (props.isFourStar) selectedStars.push("4");
  if (props.isThreeStar) selectedStars.push("3");
  if (props.isTwoStar) selectedStars.push("2");
  if (props.isOneStar) selectedStars.push("1");
  if (props.allstar) selectedStars.push("All");

  return selectedStars.length === 0 ? "Select Rating" : selectedStars.join(', ')+ " Star";
};
const ratingLabel = getRatingLabel(props);
console.log("all logs",ratingLabel)

const getFareType =(props) =>{
  const selectedFareType = [];
  if (props.selectedCheckBoxes?.room_type?.[0] === true) selectedFareType.push("Refundable");
  if (props.selectedCheckBoxes?.room_type?.[1] === true) selectedFareType.push("Non Refundable");

  return selectedFareType.length === 0 ? "Select Fare Type" : selectedFareType.join(', ');
  
}

const FareTypeLabel = getFareType(props);

const getBreakfastLabel = (props) => {
  const selectedBreakfast = [];
  
  // Check if "All" is selected
  if (props.selectedCheckBoxes["breakfast"]?.at(2)) {
    return "All";
  }
  
  // Check individual selections
  if (props.selectedCheckBoxes["breakfast"]?.at(0)) selectedBreakfast.push("With Breakfast");
  if (props.selectedCheckBoxes["breakfast"]?.at(1)) selectedBreakfast.push("Without Breakfast");
  
  return selectedBreakfast.length === 0 ? "Select Breakfast" : selectedBreakfast.join(', ');
};

const breakfastLabel = getBreakfastLabel(props);



  return (
   <>
          <div className={props.styles.advmodal_dropcontent} id="advanceSearchForm">
            <div className={props.styles.adv_dropMaincontFlx}>
              <div ref={props.rtSearchWrapper} className={props.styles.adv_dropMainBox}>
                <div  className={props.styles.hotel_type_container}>
                  <label className={props.styles.hotel_type_label}>Fare Type</label>
                </div>
                <div className={props.styles.dropMain_container}>
                  <div className={props.styles.adv_main_bx}
                   onClick={() => props?.onClickRoomTypeSearch()}>
                      <div className={props.styles.adv_flx}>
                        <div className={props.styles.icon_div}>
                          <svg xmlns="http://www.w3.org/2000/svg" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 200 200">
                            <path class="st0" d="M27.4,101.3c-2.3,1-5,1.1-7.4,0.4c-1.6-0.5-3,0.3-4.1-2.8c2.3-1.4-1.7-3-1.9-4.7c-0.3-3.1,3.2-6.2,2.8-8.6  c0.1-0.1,0.2-0.3,0.4-0.4l80.9-51.7c0.9-0.8,5.1-0.9,3.1-0.1l81,51.7c0.1,0.1,0.2,0.2,0.3,0.3c2.7,2.6,3.9,6.4,4.4,11.7  c-1.7-0.1-2.4,1.3-3.5,2.5c-1,1.2,1.8,2-3.8,2.5c-2.6,0.9-5.4,0.7-7.9-0.5v66.7h-5.8V99.2c0-1.2-60.8-37.9-64-40  c-7.2,2.2-68.9,38.7-68.9,40.2v68.8h-5.8V101.3z M130,109.4h14.7l5.6,20.7h-27.1l7.6-20.7C130.8,109.4,130,109.4,130,109.4z   M140,135.7v27.6h2.8c0.7,0.1,1.1,0.6,1.1,1.3c-0.1,0.6-0.5,1-1.1,1.1h-12.1c-0.7-0.1-1.1-0.6-1.1-1.3c0.1-0.6,0.5-1,1.1-1.1h4.5  v-27.6C135.2,135.7,140,135.7,140,135.7z M95.1,165.3v0.2h-3.5v-0.2H59.3v0.2h-3.5v-0.1h-1.2c-1.1,0.8-2.1-2.4-2.9-4.3  c-0.9-0.8-1.3-1.9-1.3-3.1v-21.8c-0.9-0.2-1.7-0.6-1.5-1.1c-2-0.6-2.7-1.4-3.2-2.4c-1.4-2.6-1-5.9,1-8.1c0.8-0.1,1.9-1.5,3-1.9  c1.1-0.4,2.4-0.6,3.6-0.5c0.9,0.1,1.8,0.3,2.6,0.7v-8.3c0-4.4,0.7-6.7,2.4-8c1.7-1.3,6.9-1.3,7.7-1.3H85c4,0,6.4,0.2,7.9,1.6  c1.6,1.4,2,3.8,2,8.4v8.1c2.2-1,4.6-1,6.8,0c1.1,1.2,2,1.1,2.8,2c1.8,2.1,2.1,5.2,0.6,7.6c-0.5,1-1.3,1.8-2.2,2.4  c-0.8,0.5-1.6,0.9-2.5,1.1v21.7c0.1,1.2,1.1,2.3-1.2,3.1c-0.8,1.5-1.9,4.7-2.9,4h-1.2C95.2,165.1,95.1,165.3,95.1,165.3z   M58.1,124.5c0.7,0.8,1.2,1.8,1.5,2.8c0.2,0.6,0.3,4,0.3,1.8c0.1,0.7,0.1,1.3,0,2v2.8h35.2v-2.8c-0.6-0.6-0.6-1.3,0-1.9  c-4.1-0.1-4-1.3-3.7-1.9c0.3-0.9,0.8-1.7,1.5-2.4v-9.6c0-3.8-0.3-5.8-1.4-6.8c-1.1-0.9-3.1-1-6.5-1H66c-3.2,0-5.3,0-6.4,0.9  c-1.1,0.9-1.5,2.6-1.5,6.3V124.5z M59.9,136.1v3.6h35.2v-3.6H59.9z M53.2,124.3c-0.9-0.1-1.8,0.1-2.7,0.4c-1,0.8-4,3.6-3.2,6.2  c0.1,0.3,0.2,0.6,0.4,0.9c2.5,0.6,0.7,1.2,1.3,3.8c0.8-1.7,1.7-1.4,2.7-1.2c0.5,0.1,2.7,0.5,2.7,1V158c-1.9,0.5-0.5,1.1-1.4,1.5  c0.5,0.3,1,0.5,1.6,0.5h3.2v-29c0.1-0.6,0.1-1.1,0-1.7c0,3.2,3.5-0.9,2-1.4C57,125.9,55.3,124.5,53.2,124.3z M93.2,134.7  c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3v5.2c0,0.2,0,0.3,0,0.5v18.9h3.2c0.6,0.1,1.1-0.1,1.6-0.4c0.4-0.4,0.5-0.9,0.5-1.5v-22.6  c0-0.5,0.4-1,0.9-1.1c3.4-0.2,1.8-0.5,2.6,0.5c0.6-1.9,1.1-2.4,1.4-3c1-1.6,0.9-3.7-0.3-5.2c-0.5-0.6-1.2-1.1-2-1.4  c1.4-0.3-1.7-0.5-2.5-0.5c-2.2-0.1-4.3,1.3-5.1,3.4c-0.1,0.4-0.2,4.6-0.3,1.2c-0.1,0.6-0.1,1.2,0,1.8L93.2,134.7  C93.2,134.7,93.2,134.7,93.2,134.7z M60,159.9h35.1v-18.1H59.9L60,159.9C59.9,159.9,60,159.9,60,159.9z M152.1,37l20,0.8v26.9  l-20-9.5V37z"/>
                          </svg>
                        </div>
                        <div
                         className={props.styles.text_div}> 
                          {/* {props.selectedCheckBoxes["room_type"]?.[0]?"Refundable":props.selectedCheckBoxes["room_type"]?.[1]?"Non Refundable":props.selectedCheckBoxes["room_type"]?.at(2)?"All":"Fare Type"} */}
                        {FareTypeLabel}
                        </div>
                      </div>
                      <div className={props.styles.dropdown_icon_div}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8"><path fill-rule="evenodd" fill="#01445F" d="M11.606.458c.704-.008 1.103.082 1.515.021a1.073 1.073 0 0 1-.021 1.517L7.746 7.198l-.747-.769.748.772a1.072 1.072 0 0 1-1.554-.061L.942 1.996A1.074 1.074 0 0 1 .921.479C1.334.54 2.12.45 2.437.458L7.2 4.931 11.606.458z"></path></svg>
                      </div>
                  </div>
                  {props.isRoomTypeSearch &&
                  <div className={props.styles.dropDownlistmain}>
                        <ul className={props.styles.dropdown_value_container}>
                        {/* <li>
                            <label className={props.styles.checkbox_label}>
                              <span className={props.styles.bagCheckbox}>
                              <input type="checkbox" id="refundable" value="Refundable" name="room_type" onChange={(e) => {  props.handleCheckboxSelection(e,2) }} checked={props.selectedCheckBoxes["room_type"]?.at(2) } className={props.styles.pointer} />
                                <span className={props.styles.bagBox}>
                                  <span className={props.styles.bagCheck}></span>
                                </span>
                              </span>
                              <span className={props.styles.advTitle}>All</span>
                            </label>
                          </li> */}
                          <li>
                            <label className={props.styles.checkbox_label}>
                              <span className={props.styles.bagCheckbox}>
                                <input type="checkbox" id="refundable" value="Refundable" name="room_type" onChange={(e) => {  props.handleCheckboxSelection(e,0) }} checked={props.selectedCheckBoxes["room_type"]?.[0] } className={props.styles.pointer} />
                                <span className={props.styles.bagBox}>
                                  <span className={props.styles.bagCheck}></span>
                                </span>
                              </span>
                              <span className={props.styles.advTitle}>Refundable</span>
                            </label>
                          </li>
                          <li>
                            <label className={props.styles.checkbox_label}>
                              <span className={props.styles.bagCheckbox}>
                                <input type="checkbox" id="refundable" value="Refundable" name="room_type" onChange={(e) => {  props.handleCheckboxSelection(e,1) }} checked={props.selectedCheckBoxes["room_type"]?.[1] } className={props.styles.pointer} />
                                <span className={props.styles.bagBox}>
                                  <span className={props.styles.bagCheck}></span>
                                </span>
                              </span>
                              <span className={props.styles.advTitle}>Non Refundable</span>
                            </label>
                          </li>
                        </ul>
                  </div>
                  }
                </div>
              </div>
              <div ref={props.bfSearchWrapper} className={props.styles.adv_dropMainBox}>
                <div className={props.styles.hotel_type_container}>
                  <label className={props.styles.hotel_type_label}>
                   Breakfast
                  </label>
                </div>
                <div className={props.styles.dropMain_container}>
                  <div className={props.styles.adv_main_bx}
                   onClick={() => props?.onClickBreakfastSearch()}>
                      <div className={props.styles.adv_flx}>
                        <div className={props.styles.icon_div}>
                            <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 200 200">

                              <g>
                                <path class="st0" d="M165.4,121.9c3.5-2.8,5.8-7.1,5.8-11.9c0-8.3-6.8-15.1-15.1-15.1h-55l2-25.6c3-1,5.2-3.8,5.2-7.1   c0-4.2-3.4-7.6-7.6-7.6H73.3l1.9-15.1h25.5V24.3H71.4c-6.2,0-11.4,4.4-12.4,10.5l-3.3,19.7H30.1c-4.2,0-7.6,3.4-7.6,7.6   c0,3.3,2.2,6.1,5.2,7.1l4.2,54.9c-6.2,4-9.4,8.6-9.4,13.6v15.1c0,13.4,27.4,27.7,78.1,27.7s78.1-14.3,78.1-27.7v-15.1   C178.8,131.8,174.2,126.4,165.4,121.9z M173.7,137.7c0,5-6.4,10.2-17.4,14.4c0.3-1,0.7-1.9,1.1-2.7c0.7-1.2,1.9-2.5,3.2-3.9   c2.6-2.8,5.5-5.9,5.5-10.2c0-4.1-2.7-7.2-5.2-9.9C169.1,129.1,173.7,133.5,173.7,137.7z M116.1,152.9c-0.6-2.1-1.2-4.2-2.3-6.1   c-1-1.8-2.5-3.3-3.9-4.9c-2.2-2.3-4.2-4.5-4.2-6.8c0-2.3,2-4.5,4.2-6.8c1.4-1.5,2.9-3.1,3.9-4.9c1-1.8,1.7-4,2.3-6.1   c0.9-3,1.7-5.9,3.5-7c0.6-0.4,1.4-0.5,2.2-0.5c1.5,0,3.3,0.4,5.1,0.9c2.1,0.5,4.3,1,6.5,1c2.2,0,4.4-0.5,6.5-1   c2.9-0.7,5.7-1.3,7.4-0.4c1.8,1.1,2.6,3.9,3.5,7c0.6,2.1,1.2,4.2,2.3,6.1c1,1.8,2.5,3.3,3.9,4.9c2.2,2.3,4.2,4.5,4.2,6.8   c0,2.3-2,4.5-4.2,6.8c-1.4,1.5-2.9,3.1-3.9,4.9c-1,1.8-1.7,4-2.3,6.1c-0.9,3-1.7,5.9-3.5,7c-1.7,1-4.4,0.3-7.4-0.4   c-2.1-0.5-4.3-1-6.5-1c-2.2,0-4.4,0.5-6.5,1c-2.9,0.7-5.7,1.3-7.4,0.4C117.8,158.8,117,155.9,116.1,152.9z M65.4,110   c0-5.2,4-9.5,9.1-10L85,110.5c-1.3-0.3-2.7-0.5-4.5-0.5c-5.1,0-7.7,1.5-10.1,2.9c-1.2,0.7-2.4,1.4-3.9,1.8   C65.8,113.2,65.4,111.6,65.4,110z M117,106.2c-0.3,0.2-0.6,0.4-0.9,0.6l-6.9-6.9h20.6l6.6,6.6c-1.1,0.2-2.1,0.4-3,0.4   c-1.6,0-3.4-0.4-5.3-0.9C124.5,105.1,120.5,104.1,117,106.2z M112.5,110.3c-3,0.5-5,1.6-6.8,2.6c-2.1,1.2-3.8,2.2-7.6,2.2   c-0.6,0-1.1,0-1.5-0.1l-15-15h20.6L112.5,110.3z M62.9,120.1c5.1,0,7.7-1.5,10.1-2.9c2.1-1.2,3.8-2.2,7.6-2.2c3.7,0,5.5,1,7.6,2.2   c2.3,1.3,5,2.9,10.1,2.9c5.1,0,7.7-1.5,10.1-2.8c1-0.6,2-1.1,3.1-1.5c0,0.1-0.1,0.2-0.1,0.3c-0.5,1.9-1.1,3.7-1.8,5   c-0.7,1.2-1.9,2.5-3.2,3.9c-1.3,1.4-2.7,2.9-3.7,4.5c-1.3,0.4-2.7,0.7-4.3,0.7c-3.7,0-5.5-1-7.6-2.2c-2.3-1.3-5-2.9-10.1-2.9   c-5.1,0-7.7,1.5-10.1,2.9c-2.1,1.2-3.8,2.2-7.6,2.2c-3.7,0-5.5-1-7.6-2.2c-1.9-1.1-4.1-2.3-7.5-2.7v-10c2.1,0.3,3.5,1.1,5,2   C55.1,118.5,57.8,120.1,62.9,120.1z M47.8,130.3c2.1,0.3,3.5,1.1,5,2c2.3,1.3,5,2.9,10.1,2.9c5.1,0,7.7-1.5,10.1-2.9   c2.1-1.2,3.8-2.2,7.6-2.2c3.7,0,5.5,1,7.6,2.2c2.3,1.3,5,2.9,10.1,2.9c0.9,0,1.7-0.1,2.5-0.2c0,0.1,0,0.1,0,0.2   c0,3.4,1.9,6.1,4,8.5c-1.7,0.9-3.4,1.6-6.5,1.6c-3.7,0-5.5-1-7.6-2.2c-2.3-1.3-5-2.9-10.1-2.9c-5.1,0-7.7,1.5-10.1,2.9   c-2.1,1.2-3.8,2.2-7.6,2.2c-3.7,0-5.5-1-7.6-2.2c-1.9-1.1-4-2.3-7.5-2.7V130.3z M166.2,110c0,5.3-4.1,9.6-9.2,10   c-0.5-1.2-0.9-2.5-1.3-3.9c-1.1-3.7-2.3-7.8-5.8-9.9c-2.3-1.4-5-1.4-7.5-1l-5.3-5.3h19.1C161.7,99.9,166.2,104.4,166.2,110z    M64,35.7c0.6-3.7,3.7-6.3,7.5-6.3h24.2v5H75.2c-2.5,0-4.7,1.9-5,4.4l-2,15.7h-7.4L64,35.7z M30.1,59.6h70.5c1.4,0,2.5,1.1,2.5,2.5   c0,1.4-1.1,2.5-2.5,2.5H30.1c-1.4,0-2.5-1.1-2.5-2.5S28.7,59.6,30.1,59.6z M32.9,69.7H98L96,94.9H75.5c-8.3,0-15.1,6.8-15.1,15.1   c0,1.7,0.3,3.4,0.9,5c-2.7-0.3-4.2-1.1-5.9-2.1c-2.3-1.3-5-2.9-10.1-2.9h-2.5v8.8c-2.1,0.8-4.1,1.7-5.9,2.5L32.9,69.7z M42.7,124.2   v21h2.5c3.7,0,5.5,1,7.6,2.2c2.3,1.3,5,2.9,10.1,2.9c5.1,0,7.7-1.5,10.1-2.9c2.1-1.2,3.8-2.2,7.6-2.2c3.7,0,5.5,1,7.6,2.2   c2.3,1.3,5,2.9,10.1,2.9c5,0,7.6-1.5,10-2.8c0.5,0.6,1,1.2,1.3,1.8c0.8,1.3,1.3,3.1,1.8,5c0.5,1.9,1.1,3.9,2.1,5.7   c-4.2,0.2-8.4,0.4-12.6,0.4c-43.1,0-73.1-12-73.1-22.7C27.6,133.1,33.1,128.2,42.7,124.2z M173.7,152.8c0,10.7-30,22.7-73.1,22.7   s-73.1-12-73.1-22.7v-5.2c10.1,9.7,35,17.7,73.1,17.7c5.9,0,11.8-0.2,17.4-0.7c1.2,0.5,2.4,0.7,3.7,0.7c2.1,0,4.3-0.5,6.3-1   c1.9-0.5,3.7-0.9,5.3-0.9c1.6,0,3.4,0.4,5.3,0.9c3.6,0.9,7.7,1.8,11.1-0.2c2.3-1.4,3.6-3.7,4.6-6.1c8.7-2.8,15.2-6.3,19.3-10.2   L173.7,152.8L173.7,152.8z"/>
                                <path class="st0" d="M133.4,152.8c9.7,0,17.6-7.9,17.6-17.6s-7.9-17.6-17.6-17.6s-17.6,7.9-17.6,17.6S123.7,152.8,133.4,152.8z    M133.4,122.6c6.9,0,12.6,5.7,12.6,12.6c0,6.9-5.7,12.6-12.6,12.6c-6.9,0-12.6-5.7-12.6-12.6C120.8,128.2,126.5,122.6,133.4,122.6z   "/>
                                
                                  <rect x="39.8" y="84.8" transform="matrix(0.9971 -7.669650e-02 7.669650e-02 0.9971 -6.5687 3.5024)" class="st0" width="5" height="5"/>
                                
                                  <rect x="39" y="74.7" transform="matrix(0.9971 -7.669650e-02 7.669650e-02 0.9971 -5.8003 3.4134)" class="st0" width="5" height="5"/>
                                
                                  <rect x="40.6" y="94.8" transform="matrix(0.9971 -7.669650e-02 7.669650e-02 0.9971 -7.3373 3.5913)" class="st0" width="5" height="5"/>
                              </g>
                            </svg>
                        </div>
                        <div
                         className={props.styles.text_div}>
                          
                          {/* {props.selectedCheckBoxes["breakfast"]?.at(0)?"With Breakfast":props.selectedCheckBoxes["breakfast"]?.at(1)?"Without Breakfast":props.selectedCheckBoxes["breakfast"]?.at(2)?"All":"Select Breakfast"} */}
                          {breakfastLabel}
                        </div>
                      </div>
                      <div className={props.styles.dropdown_icon_div}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8"><path fill-rule="evenodd" fill="#01445F" d="M11.606.458c.704-.008 1.103.082 1.515.021a1.073 1.073 0 0 1-.021 1.517L7.746 7.198l-.747-.769.748.772a1.072 1.072 0 0 1-1.554-.061L.942 1.996A1.074 1.074 0 0 1 .921.479C1.334.54 2.12.45 2.437.458L7.2 4.931 11.606.458z"></path></svg>
                      </div>
                  </div>
                  {props.isBreakfastSearch &&
                  <div className={props.styles.dropDownlistmain}>
  <ul className={props.styles.dropdown_value_container}>
    <li>
      <label className={props.styles.checkbox_label}>
        <span className={props.styles.bagCheckbox}>
          <input 
            type="checkbox" 
            id="breakfast_all" 
            value="all" 
            name="breakfast" 
            onChange={(e) => { props.handleBreakfastAllSelection(e) }} 
            checked={props.selectedCheckBoxes["breakfast"]?.at(2) || false} 
            className={props.styles.pointer} 
          />
          <span className={props.styles.bagBox}>
            <span className={props.styles.bagCheck}></span>
          </span>
        </span>
        <span className={props.styles.advTitle}>All</span>
      </label>
    </li>
    <li>
      <label className={props.styles.checkbox_label}>
        <span className={props.styles.bagCheckbox}>
          <input 
            type="checkbox" 
            id="breakfast_with" 
            value="withBreakfast" 
            name="breakfast" 
            onChange={(e) => { props.handleBreakfastSelection(e, 0) }} 
            checked={props.selectedCheckBoxes["breakfast"]?.at(0) || false} 
            className={props.styles.pointer} 
          />
          <span className={props.styles.bagBox}>
            <span className={props.styles.bagCheck}></span>
          </span>
        </span>
        <span className={props.styles.advTitle}>With Breakfast</span>
      </label>
    </li>
    <li>
      <label className={props.styles.checkbox_label}>
        <span className={props.styles.bagCheckbox}>
          <input 
            type="checkbox" 
            id="breakfast_without" 
            value="withoutBreakfast" 
            name="breakfast" 
            onChange={(e) => { props.handleBreakfastSelection(e, 1) }} 
            checked={props.selectedCheckBoxes["breakfast"]?.at(1) || false} 
            className={props.styles.pointer} 
          />
          <span className={props.styles.bagBox}>
            <span className={props.styles.bagCheck}></span>
          </span>
        </span>
        <span className={props.styles.advTitle}>Without Breakfast</span>
      </label>
    </li>
  </ul>
                  </div>
                  }
                </div>
              </div>
              <div ref={props.starSearchWrapper}  className={props.styles.adv_dropMainBox}>
                <div  className={props.styles.hotel_type_container}>
                  <label className={props.styles.hotel_type_label}>Rating</label>
                </div>
                <div  className={props.styles.dropMain_container}>
                  <div className={props.styles.adv_main_bx}
                   onClick={() => props?.onClickStarSearch()}>
                      <div className={props.styles.adv_flx}>
                        <div className={props.styles.icon_div}>
                          <svg xmlns="http://www.w3.org/2000/svg" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 200 200">
                              <g>
                                <path class="st0" d="M55.1,179c-1.2,0-2.5-0.3-4-1.1l-1.5-0.7l-0.7-1.5c-0.6-1.3-1.5-3-1.5-5.2v-0.4l7.9-47.4L20.5,88.9l-0.4-0.8   c-0.7-1.4-2.1-4.2-0.5-7.4c1.3-2.7,3.8-4.5,6.4-4.7l46.8-6.9l20.7-42.9c1.3-2.7,4-4.3,6.9-4.3c0,0,0,0,0,0c3,0,5.6,1.6,6.9,4.2   l20.8,42.9l46.7,6.9c4.2,0.2,5.9,3.6,6.5,4.7l0,0c1.6,3.2,0.2,6-0.5,7.4l-0.4,0.8l-34.7,33.8l7.8,46.6c0.5,1.4,0.5,3,0,4.5   c-0.5,1.5-1.5,2.9-2.8,3.7c-1.8,1.4-3.7,1.4-4.4,1.4c-1,0-1.8-0.2-2.4-0.5h-0.3l-43-22.7l-41.4,21.9C58.1,178.4,56.8,179,55.1,179z    M100.5,144.4l42.5,22.4l-8-47.7l34.7-33.8l-48.3-7.1l-21-43.4l-21,43.4l-48.3,7.1L66,119.1l-8,47.7L100.5,144.4z"></path>
                              </g>
                          </svg>
                        </div>
                        <div
                         className={props.styles.text_div}>
                          {/* {props.isOneStar && props.isTwoStar && props.isThreeStar && props.isFourStar && props.isFiveStar ? "5 Star" : props.isOneStar && props.isTwoStar && props.isThreeStar && props.isFourStar  ? "4 Star":props.isOneStar && props.isTwoStar && props.isThreeStar  ? "3 Star":props.isOneStar && props.isTwoStar  ? "2 Star":
                          props.isOneStar  ? "1 Star":props.isTwoStar  ? "2 Star":props.isThreeStar  ? "3 Star":props.isFourStar  ? "4 Star":props.isFiveStar  ? "5 Star":props.allstar?"All":"Select Rating"} */}
                         {ratingLabel}
                          {/* {props.isFiveStar?"5 Star":props.isFourStar?"4 Star":props.isThreeStar?"3 Star":props.isTwoStar?"2 Star":props.isOneStar?"1 Star":props.allstar?"All":"Select Rating"} */}
                        </div>
                      </div>
                      <div className={props.styles.dropdown_icon_div}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8"><path fill-rule="evenodd" fill="#01445F" d="M11.606.458c.704-.008 1.103.082 1.515.021a1.073 1.073 0 0 1-.021 1.517L7.746 7.198l-.747-.769.748.772a1.072 1.072 0 0 1-1.554-.061L.942 1.996A1.074 1.074 0 0 1 .921.479C1.334.54 2.12.45 2.437.458L7.2 4.931 11.606.458z"></path></svg>
                      </div>
                  </div>
                  {props.isStarSearch &&
                  <div className={props.styles.dropDownlistmain}>
                        <ul className={props.styles.dropdown_value_container}>
                        
                          <li>
                            <label className={props.styles.checkbox_label}>
                              <span className={props.styles.bagCheckbox}>
                                <input type="checkbox" id="1" name="isOneStar" onChange={(e) => { props.applyb2bFilters('star', e, this,0);props.handleStarCheck(e)}} checked={props.isOneStar} value="1" className={props.styles.pointer} />
                                <span className={props.styles.bagBox}>
                                  <span className={props.styles.bagCheck}></span>
                                </span>
                              </span>
                              <span className={props.styles.advTitle}>1 Star </span>
                            </label>
                          </li>
                          <li>
                            <label className={props.styles.checkbox_label}>
                              <span className={props.styles.bagCheckbox}>
                                <input type="checkbox" id="2" name="isTwoStar" onChange={(e) => { props.applyb2bFilters('star', e, this,1);props.handleStarCheck(e)}} checked={props.isTwoStar}  value="2" className={props.styles.pointer} />
                                <span className={props.styles.bagBox}>
                                  <span className={props.styles.bagCheck}></span>
                                </span>
                              </span>
                              <span className={props.styles.advTitle}>2 Star </span>
                            </label>
                          </li>
                          <li>
                            <label className={props.styles.checkbox_label}>
                              <span className={props.styles.bagCheckbox}>
                                <input type="checkbox" id="3" name="isThreeStar" onChange={(e) => { props.applyb2bFilters('star', e, this,2);props.handleStarCheck(e)}} checked={props.isThreeStar}  value="3" className={props.styles.pointer} />
                                <span className={props.styles.bagBox}>
                                  <span className={props.styles.bagCheck}></span>
                                </span>
                              </span>
                              <span className={props.styles.advTitle}>3 Star </span>
                            </label>
                          </li>
                          <li>
                            <label className={props.styles.checkbox_label}>
                              <span className={props.styles.bagCheckbox}>
                                <input type="checkbox" id="4" name="isFourStar" onChange={(e) => { props.applyb2bFilters('star', e, this,3);props.handleStarCheck(e)}} checked={props.isFourStar}  value="4" className={props.styles.pointer} />
                                <span className={props.styles.bagBox}>
                                  <span className={props.styles.bagCheck}></span>
                                </span>
                              </span>
                              <span className={props.styles.advTitle}>4 Star </span>
                            </label>
                          </li>
                          <li>
                            <label className={props.styles.checkbox_label}>
                              <span className={props.styles.bagCheckbox}>
                                <input type="checkbox" id="5" name="isFiveStar" onChange={(e) => { props.applyb2bFilters('star', e, this,4);props.handleStarCheck(e)}} checked={props.isFiveStar}  value="5" className={props.styles.pointer} />
                                <span className={props.styles.bagBox}>
                                  <span className={props.styles.bagCheck}></span>
                                </span>
                              </span>
                              <span className={props.styles.advTitle}>5 Star </span>
                            </label>
                          </li>
                        </ul>
                  </div>
                  }
                </div>
              </div>
            </div>
            
          </div>
   </>
  );
}
